import { ifAuthenticated, ifUserInTeam } from "#/stores/auth";

function load(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `./${view}.vue`);
}

const routes = {
  path: "deliveries",
  component: load("Base"),
  beforeEnter: ifAuthenticated,
  children: [
    {
      path: "",
      name: "deliveries.list",
      component: load("List"),
      beforeEnter: ifUserInTeam,
      meta: {
        isBypassingPageTransition: true,
        layout: "dashboard"
      },

      children: [
        {
          path: ":uid([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/detail",
          name: "deliveries.detail",
          component: load("Detail"),
          meta: {
            isBypassingPageTransition: true,
            layout: "dashboard"
          }
        }
      ]
    }
  ]
};

export default routes;
